"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var clsx_1 = require("clsx");
var core_1 = require("@material-ui/core");
var client_1 = require("@apollo/client");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var useUrlDealId_1 = require("../../../common/hooks/useUrlDealId");
var cache_1 = require("../../../common/graphql/cache");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var useSelectJourneyType_1 = require("../../hooks/mutations/useSelectJourneyType");
var journeyListStyles_1 = require("./journeyListStyles");
var globalTypes_1 = require("../../../../__generated__/globalTypes");
var ScrollInViewTypes_1 = require("../../../../common/enum/ScrollInViewTypes");
var ContinueButton_1 = require("../buttons/continueButton/ContinueButton");
var useJourneyStepsContext_1 = require("../../hooks/useJourneyStepsContext");
var useStockApiPing_1 = require("../../../common/hooks/queries/useStockApiPing");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var softLockModal_1 = require("../../../checkout4/components/softLockModal/softLockModal");
var errorHandler_1 = require("../../../../gql/common/service/errorHandler");
var usePreOrderOnlineExternal_1 = require("../../hooks/queries/usePreOrderOnlineExternal");
var useJourneyListContext_1 = require("../../context/journeys/useJourneyListContext");
var useHasJourney_1 = require("../../hooks/useHasJourney");
var JourneyStepsRoutes_1 = require("../../enum/JourneyStepsRoutes");
var useCallDigitalAssignmentEntryEvent_1 = require("../../../common/hooks/dataLayer/useCallDigitalAssignmentEntryEvent");
var useWidgetContext_1 = require("../../../../common/react/useWidgetContext");
var dataLayerToggleVerification_1 = require("../../../../../../common/utilities/dataLayerToggleVerification");
var useSalesEnablementContext_1 = require("../../../../gql/common/hooks/useSalesEnablementContext");
var DealStatus_1 = require("../../enum/DealStatus");
var JourneyList = function () {
    var _a, _b, _c;
    var _d = usePlatformConfig_1.default().platformConfig, checkout = _d.checkout, _e = _d.platformFeatures, isReservationJourneyOptional = _e.isReservationJourneyOptional, isDisabledReservationJourneyLabel = _e.isDisabledReservationJourneyLabel, hasOptionalJourneys = _e.hasOptionalJourneys;
    var _f = checkout || {}, hideJourneySelection = _f.hideJourneySelection, hideSelectJourneyContinueButton = _f.hideSelectJourneyContinueButton, hideDefaultJourneyHighlight = _f.hideDefaultJourneyHighlight, skipJourneyStepOnSalesEnablement = _f.skipJourneyStepOnSalesEnablement;
    var styles = journeyListStyles_1.default();
    var isOrderPlacementDisabled = useStockApiPing_1.default().isOrderPlacementDisabled;
    var isInSalesEnablement = useSalesEnablementContext_1.default().isInSalesEnablement;
    var _g = react_1.useState(false), softLocked = _g[0], setSoftLocked = _g[1];
    var _h = react_1.useState(false), isNextDisabled = _h[0], setIsNextDisabled = _h[1];
    var _j = react_1.useState(false), isLoading = _j[0], setIsLoading = _j[1];
    var _k = react_1.useState(hideDefaultJourneyHighlight), hideDefaultJourneyOnFirstStep = _k[0], setHideDefaultJourneyOnFirstStep = _k[1];
    var dealId = useUrlDealId_1.default();
    var _l = useCheckoutContext_1.default(), setDeal = _l.setDeal, deal = _l.deal;
    var selectJourney = useSelectJourneyType_1.useSelectJourney().selectJourney;
    var _m = useJourneyStepsContext_1.default(), steps = _m.steps, handleNext = _m.handleNext, changeActiveStep = _m.changeActiveStep, isFirstLoad = _m.isFirstLoad, setIsFirstLoad = _m.setIsFirstLoad;
    var _o = useJourneyListContext_1.default(), journeyList = _o.journeyList, updateJourneyList = _o.updateJourneyList;
    var userJourney = client_1.useReactiveVar(cache_1.activeJourneyType);
    var hasJourney = useHasJourney_1.default().hasJourney;
    var hasPreOrderJourney = hasJourney(globalTypes_1.JourneyType.pre_order_now);
    var listRef = react_1.useRef(null);
    var postCode = (((_a = deal) === null || _a === void 0 ? void 0 : _a.dealer) || {}).postCode;
    var stockType = (((_b = deal) === null || _b === void 0 ? void 0 : _b.car.stock) || {}).stockType;
    var _p = usePreOrderOnlineExternal_1.usePreOrderOnlineExternal(dealId, postCode), fetchPreOrderOnlineExternal = _p.fetchPreOrderOnlineExternal, preOrderExternalLink = _p.data, errorPreOrder = _p.error, loadingPreOrder = _p.loading;
    var skipJourneySelectionOnSingleJourney = hideSelectJourneyContinueButton && journeyList.length == 1;
    var _q = react_1.useState(journeyList), handleJourneyList = _q[0], setHandleJourneyList = _q[1];
    var dimensions = useWidgetContext_1.default().configuration.dimensions;
    var callDigitalAssignmentEntryEvent = useCallDigitalAssignmentEntryEvent_1.default().callDigitalAssignmentEntryEvent;
    react_1.useEffect(function () {
        setIsNextDisabled(userJourney === globalTypes_1.JourneyType.save_my_build);
        if (hideSelectJourneyContinueButton) {
            setIsNextDisabled(false);
        }
    }, [userJourney]);
    react_1.useEffect(function () {
        if (hasPreOrderJourney) {
            fetchPreOrderOnlineExternal();
        }
    }, []);
    react_1.useEffect(function () {
        var _a;
        if (userJourney === globalTypes_1.JourneyType.pre_order_now) {
            setIsNextDisabled(loadingPreOrder || !!errorPreOrder || !((_a = preOrderExternalLink) === null || _a === void 0 ? void 0 : _a.preOrderOnlineExternal));
            setIsLoading(loadingPreOrder);
        }
    }, [userJourney, loadingPreOrder, errorPreOrder, preOrderExternalLink]);
    var onClickHandler = function (journeyType) {
        if (!isLoading) {
            if (handleListItemDisable(journeyType))
                return;
            cache_1.activeJourneyType(journeyType);
            if (hideSelectJourneyContinueButton && !isNextDisabled) {
                setHideDefaultJourneyOnFirstStep(false);
                handleNextClick();
            }
            else {
                listRef.current.scrollIntoView({
                    behavior: ScrollInViewTypes_1.ScrollInViewBehaviourType.SMOOTH,
                    block: ScrollInViewTypes_1.ScrollInViewBlockType.CENTER,
                });
            }
        }
    };
    react_1.useEffect(function () {
        var _a, _b;
        if (isInSalesEnablement && skipJourneyStepOnSalesEnablement && isFirstLoad) {
            var isFailedStatus = ((_a = deal) === null || _a === void 0 ? void 0 : _a.status) === DealStatus_1.DealStatus.FAILED;
            var isAuthorizedStatus = ((_b = deal) === null || _b === void 0 ? void 0 : _b.status) === DealStatus_1.DealStatus.AUTHORIZED;
            setIsFirstLoad(false);
            if (!isFailedStatus && !isAuthorizedStatus) {
                cache_1.activeJourneyType(globalTypes_1.JourneyType.continue_in_dealership);
                handleNextClick();
            }
            else {
                handleNext();
            }
        }
        else if (hideJourneySelection || skipJourneySelectionOnSingleJourney) {
            handleNext();
        }
    }, []);
    var handleNextStep = react_1.useCallback(function () {
        if (stockType === globalTypes_1.StockType.dealer) {
            var dealerStep = steps.findIndex(function (step) { return step.pathname === JourneyStepsRoutes_1.JourneyStepsRoutes.DEALER; });
            //jump directly to Customer Information since Dealer cannot be changed
            changeActiveStep(dealerStep + 1);
        }
        else {
            handleNext();
        }
    }, [stockType, steps, changeActiveStep, handleNext]);
    var handleNextClick = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var journeyType, isDataLayer, data, e_1, setSoftLockedError;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsNextDisabled(true);
                    setIsLoading(true);
                    journeyType = cache_1.activeJourneyType();
                    isDataLayer = dataLayerToggleVerification_1.default(dimensions);
                    if (isDataLayer && journeyType === globalTypes_1.JourneyType.online_order) {
                        callDigitalAssignmentEntryEvent({ deal: deal, dimensions: dimensions });
                    }
                    if (journeyType === globalTypes_1.JourneyType.pre_order_now && ((_a = preOrderExternalLink) === null || _a === void 0 ? void 0 : _a.preOrderOnlineExternal)) {
                        window.location.replace(preOrderExternalLink.preOrderOnlineExternal);
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, selectJourney(dealId, journeyType)];
                case 2:
                    data = _c.sent();
                    setDeal(data.selectJourneyType);
                    handleNextStep();
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _c.sent();
                    setSoftLockedError = errorHandler_1.default.handleSoftLock(e_1);
                    setSoftLocked((_b = setSoftLockedError) === null || _b === void 0 ? void 0 : _b.isStockLocked);
                    return [3 /*break*/, 5];
                case 4:
                    setIsNextDisabled(false);
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [dealId, preOrderExternalLink]);
    var handleListItemDisable = function (journeyType) {
        return (journeyType === globalTypes_1.JourneyType.online_order && isOrderPlacementDisabled) ||
            (journeyType === globalTypes_1.JourneyType.reserve_online && isOrderPlacementDisabled) ||
            (journeyType === globalTypes_1.JourneyType.pre_order_now && !!errorPreOrder);
    };
    var handleListItemText = function (description, journeyType) {
        if (isDisabledReservationJourneyLabel && journeyType === globalTypes_1.JourneyType.reserve_online) {
            return handleListItemDisable(journeyType)
                ? 'trans__checkout__next_step__reserve_your_car_description'
                : description;
        }
        return handleListItemDisable(journeyType) ? 'trans__checkout__next_step__order_now_eod_message' : description;
    };
    var handleSoftLockContinueBtn = function () {
        updateJourneyList(globalTypes_1.JourneyType.online_order);
        setSoftLocked(false);
        cache_1.activeJourneyType(globalTypes_1.JourneyType.continue_in_dealership);
    };
    react_1.useEffect(function () {
        var _a;
        if (isReservationJourneyOptional && !((_a = deal) === null || _a === void 0 ? void 0 : _a.car.isForReservation)) {
            setHandleJourneyList(journeyList.filter(function (journey) { return journey.journeyType !== globalTypes_1.JourneyType.reserve_online; }));
        }
        else {
            setHandleJourneyList(journeyList);
        }
        if (hasOptionalJourneys) {
            if (stockType === globalTypes_1.StockType.dealer) {
                setHandleJourneyList(journeyList.filter(function (journey) { return journey.journeyType !== globalTypes_1.JourneyType.pre_order_now; }));
            }
            else {
                setHandleJourneyList(journeyList.filter(function (journey) { return journey.journeyType !== globalTypes_1.JourneyType.online_order; }));
            }
        }
    }, [deal, journeyList]);
    var showPreOrderError = userJourney === globalTypes_1.JourneyType.pre_order_now && errorPreOrder;
    return (<>
      <core_1.List className={styles.listContainer} ref={listRef} data-test="checkout:journey_list">
        {(_c = handleJourneyList) === null || _c === void 0 ? void 0 : _c.map(function (item, i) {
        var _a, _b;
        return (<core_1.ListItem className={clsx_1.default([
            styles.listItem,
            (_a = {}, _a[styles.selected] = userJourney === item.journeyType && !hideDefaultJourneyOnFirstStep, _a),
        ])} key={i} onClick={function () { return onClickHandler(item.journeyType); }} data-test={"checkout:journey:" + item.journeyType} disabled={handleListItemDisable(item.journeyType) ||
            (hideSelectJourneyContinueButton && isNextDisabled) ||
            isLoading}>
            <core_1.ListItemAvatar className={clsx_1.default(styles.icon, (_b = {},
            _b[styles.selectedIcon] = userJourney === item.journeyType && !hideDefaultJourneyOnFirstStep,
            _b))}>
              {item.icon}
            </core_1.ListItemAvatar>
            <core_1.ListItemText primary={<Translation_1.default className={styles.title} id={item.title}/>} secondary={<Translation_1.default className={styles.description} id={handleListItemText(item.description, item.journeyType)}/>} data-test="checkout:journey:details"/>
            <core_1.Radio classes={{
            root: styles.radio,
            checked: styles.checked,
        }} className={styles.radioIcon} checked={userJourney === item.journeyType && !hideDefaultJourneyOnFirstStep} name={item.journeyType} disabled={isLoading}/>
          </core_1.ListItem>);
    })}
      </core_1.List>
      {showPreOrderError && (<core_1.Typography variant="body2" className={styles.error} data-test="checkout:journey:pre-order:error">
          <Translation_1.default id="trans__checkout__errors__pre_order_journey_error"/>
        </core_1.Typography>)}
      <core_1.Box className={styles.buttonWrapper}>
        {!hideSelectJourneyContinueButton && (<ContinueButton_1.default testId="checkout:continue_button:select_journey" activateNextStep={false} disabled={isNextDisabled} handleClick={handleNextClick} loading={isLoading}/>)}
      </core_1.Box>
      <softLockModal_1.default isOpen={softLocked} handleContinueBtn={handleSoftLockContinueBtn} onClose={function () { return setSoftLocked(false); }}/>
    </>);
};
exports.default = JourneyList;
